import { api } from "./Api";
import { ApiResult } from "./ApiResult";

class ConfiguracaoService {
  async buscarValoresCredito() {
      const { data: result } = await api.get<ApiResult<number[]>>("Configuracao/BuscarValoresCreditoPix");
      return result
  }
}

export default new ConfiguracaoService();